<template>
  <piepkaart :minLoadDataZoom="0">
    <template v-slot="{ bounds, minLoadDataZoom }">
      <piepkaart-json-layer
        :bounds="bounds"
        :minLoadDataZoom="minLoadDataZoom"
        :data="data"
        :onEachFeature="onEachFeature"
        :styleOptions="styleOptions"
      ></piepkaart-json-layer>
    </template>
  </piepkaart>
</template>
<script>
import Piepkaart from "@/components/Piepkaart.vue";
import PiepkaartJsonLayer from "@/components/PiepkaartJsonLayer.vue";
import geoData from "@/assets/data/stortplaatsen_ge.json";
import L from "leaflet";
export default {
  name: "Gelderland",
  components: {
    Piepkaart,
    PiepkaartJsonLayer,
  },
  data() {
    return {
      maxBounds: L.latLngBounds([
        [51.73728773279874, 4.99872193943861],
        [52.51585214706363, 6.749152188581071],
      ]),
    };
  },
  computed: {
    data() {
      return geoData;
    },
  },
  methods: {
    styleOptions() {
      return {
        weight: 3,
        color: "#3B82F6",
        opacity: 1,
        fillColor: "#3B82F6",
        fillOpacity: 0.8,
      };
    },
    onEachFeature(feature, layer) {
      if (feature.properties) {
        layer.bindPopup(
          `
            <div>
              <div style="font-weight: 600">${feature.properties.Locatie}</div>
              <div>Beginjaar: ${feature.properties.Beginjaar}</div>
              <div>Eindjaar: ${feature.properties.Eindjaar}</div>
              <div>Adres: ${feature.properties.Adres}</div>
              <div>Plaats: ${feature.properties.Plaatsnaam}</div>
            </div>
            `,
          {
            closeButton: false,
            autoPan: false,
          }
        );
      }
    },
  },
  created() {
    this.$store.commit("center", this.maxBounds.getCenter());
    this.$store.commit("zoom", 10);
  },
};
</script>
